const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/sandboxes/$id/items.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { httpClient } from "@/lib/http-client";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { getFetchedQuery } from "@/lib/get-fetched-query";
import { getQueryClient } from "@/lib/client";
import { generateSandboxMeta } from "@/lib/generate-sandbox-meta";
import i18n from "@/lib/i18n";
interface PaginatedResponse<T> {
  elements: T[];
  page: number;
  limit: number;
  count: number;
}
export const Route = createFileRoute("/{-$locale}/sandboxes/$id/items")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context,
    params
  }) => {
    const {
      id
    } = params;
    const {
      queryClient
    } = context;
    await queryClient.prefetchQuery({
      queryKey: ["sandbox", "items", {
        id,
        page: 1,
        limit: 20,
        filters: []
      }],
      queryFn: () => httpClient.get<PaginatedResponse<SingleItem>>(`/sandboxes/${id}/items`, {
        params: {
          page: 1,
          limit: 20
        }
      })
    });
    return {
      id,
      dehydratedState: dehydrate(queryClient)
    };
  },
  head: ctx => {
    const {
      params
    } = ctx;
    const queryClient = getQueryClient();
    if (!ctx.loaderData) {
      return {
        meta: [{
          title: i18n.t("sandboxes.notFoundTitle"),
          description: i18n.t("sandboxes.notFoundDescription")
        }]
      };
    }
    const {
      id
    } = params;
    const sandbox = getFetchedQuery<SingleSandbox>(queryClient, ctx.loaderData?.dehydratedState, ["sandbox", {
      id
    }]);
    const offer = getFetchedQuery<SingleOffer>(queryClient, ctx.loaderData?.dehydratedState, ["sandbox", "base-game", {
      id
    }]);
    if (!sandbox) return {
      meta: [{
        title: i18n.t("sandboxes.notFoundTitle"),
        description: i18n.t("sandboxes.notFoundDescription")
      }]
    };
    return {
      meta: generateSandboxMeta(sandbox, offer, i18n.t("sandboxes.metaItemsTitle"))
    };
  }
});